import { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './style.module.scss'
import gsap from 'gsap';

const PageTransition = ({ children }) => {
  const transitionRef = useRef(null);

  useEffect(() => {
    const el = transitionRef.current;

    const tl = gsap.timeline();
    tl.set(el, { opacity: 1, })
      .to(el, { opacity: 0, y: 0, duration: 0.7, ease: "power2.inOut" });

    return () => {
      gsap.set(el, { clearProps: "all" });
    };
  }, []);

  return (
    <>
      <div ref={transitionRef} className={styles.pageTransition}/>
      {children}
    </>
  );
};

export default PageTransition;
